module.exports = __webpack_public_path__ + "img/bg.bb9199db.png";